export default __webpack_public_path__ + "static/media/testImg.1fbc56ac.svg";